import "core-js/es6/promise";
import "core-js/es6/string";
import "core-js/es7/array";

import Vue from "vue";
import Vuelidate from "vuelidate";
import router from "@/router";
import store from "@/store";
import i18n from "@/i18n";
import App from "@/app.vue";
// import "@/common/registerServiceWorker";

import VueResource from "vue-resource";
import BootstrapVue from "bootstrap-vue";
import VueSweetalert2 from "vue-sweetalert2";
import Snotify, { SnotifyPosition } from "vue-snotify";
import helpers from "@/plugins/helpers";
import datePicker from "vue-bootstrap-datetimepicker";
import timePicker from "vue-bootstrap-datetimepicker";
import VueApexCharts from 'vue-apexcharts';
import VueTimepicker  from 'vue2-timepicker';
import Multiselect  from 'vue-multiselect';
import VueColumnsResizable from 'vue-columns-resizable';
import VueClipboard from 'vue-clipboard2'

const options = {
  toast: {
    position: SnotifyPosition.rightTop
  }
}

Vue.config.productionTip = process.env.NODE_ENV === "production" || false;

Vue.use(BootstrapVue);
Vue.use(Vuelidate);
Vue.use(VueResource);
Vue.use(VueSweetalert2);
Vue.use(Snotify, options);
Vue.use(datePicker);
Vue.use(timePicker);
Vue.use(helpers, { $store: store, $router: router, $t: i18n, $swal: Vue.swal, $snotify: Vue });
Vue.use(VueColumnsResizable);
Vue.use(VueClipboard);
Vue.component('apexchart', VueApexCharts);
Vue.component('vuetimepicker', VueTimepicker);
Vue.component('multiselect', Multiselect);


import moment from "moment";
Object.defineProperty(Vue.prototype, "$moment", { value: moment });

// import "clusterize.js/clusterize.css";
// import clusterize from "clusterize.js";
// Object.defineProperty(Vue.prototype, '$clusterize', { value: clusterize });

/* eslint-disable no-new */
import $ from 'jquery';
import jQuery from 'jquery';

export function resizeColumn(){
  $(document).ready(function () {
    // $('table.resizable').resizableColumns();
    $('table.resizable').each(function() {
      $(this).resizableColumns();
    });
  });
  ! function(i) {
      i.fn.resizableColumns = function() {
        var t = !1,
            s = 0,
            n = i(this),
            e = i(this).find("thead").first();
        e.find("th").each(function() {
            i(this).css("position", "relative"), i(this).is(":not(:last-child)") && i(this).append("<div class='resizer' style='position:absolute;top:0px;right:-3px;bottom:0px;width:6px;z-index:999;background:transparent;cursor:col-resize'></div>")
        }), i(document).mouseup(function(i) {
            e.find("th").removeClass("resizing"), t = !1, i.stopPropagation()
        }), n.find(".resizer").mousedown(function(n) {
            e.find("th").removeClass("resizing"), i(e).find("tr:first-child th:nth-child(" + (i(this).closest("th").index() + 1) + ") .resizer").closest("th").addClass("resizing"), s = n.pageX, t = !0, n.stopPropagation()
        }), n.mousemove(function(i) {
            if (t) {
                var n = e.find("th.resizing .resizer");
                if (1 == n.length) {
                    var o = e.find("th.resizing + th"),
                        r = (i.pageX || 0) - s,
                        h = n.closest("th").innerWidth() + r,
                        d = o.innerWidth() - r;
                    // console.log(o, r, h, d);
                    // console.log(s, i);
                    0 != s && 0 != r && h > 50 && d > 50 && (n.closest("th").innerWidth(h), s = i.pageX, o.innerWidth(d))
                }
            }
        })
      }
  }(jQuery);
}

export function resizeColumn1(){
  $(function() {
    var startX,
       startWidth,
       $handle,
       $table,
       pressed = false;

    $(document).on({
      mousemove: function(event) {
        if (pressed) {
          $handle.width(startWidth + (event.pageX - startX));
        }
      },
      mouseup: function() {
        if (pressed) {
          $table.removeClass('resizing');
          pressed = false;
        }
      }
    }).on('mousedown', '.table-resizable th', function(event) {
      $handle = $(this);
      pressed = true;
      startX = event.pageX;
      startWidth = $handle.width();

      $table = $handle.closest('.table-resizable').addClass('resizing');
    }).on('dblclick', '.table-resizable thead', function() {
      // Reset column sizes on double click
      $(this).find('th[style]').css('width', '');
    });
  });
}

$.extend(true, $.fn.datetimepicker.defaults, {
  icons: {
    time: 'far fa-clock',
    date: 'far fa-calendar',
    up: 'fas fa-arrow-up',
    down: 'fas fa-arrow-down',
    previous: 'fas fa-chevron-left',
    next: 'fas fa-chevron-right',
    today: 'fas fa-calendar-check',
    clear: 'far fa-trash-alt',
    close: 'far fa-times-circle'
  }
});

router.beforeEach((to, from, next) => {
  let query = to.fullPath.match(/^\/$/) ? {} : { redirect: to.fullPath };
  let path = "/denied";

  // console.log(to, from)

  if (
    to.matched.some(record => {
      return record.meta.requiredLoggedIn && record.meta.includedPages;
    })
  ) {
    if (!store.getters.isLoggedIn) {
      next({ path: path, query: query });
      return;
    }

    let haveRole = false;
    let pages = to.matched[0].meta.includedPages;
    let roles = store.getters.accessRoles;
    for (var i = 0; i < pages.length; i++) {
      for (var j = 0; j < roles.length; j++) {
        if (roles[j].page_id == pages[i]) {
          haveRole = true;
          break;
        }
      }
    }

    if (haveRole == false) {
      next({ path: path, query: query });
      return;
    }
  }

  // if (
  //   to.matched.some(record => {
  //     return record.meta.requiredLoggedIn && record.meta.page;
  //   })
  // ) {
  //   if (!store.getters.isLoggedIn) {
  //     next({ path: path, query: query });
  //     return;
  //   }

  //   let haveRole = false;
  //   let page = to.matched[1].meta.page;
  //   let roles = store.getters.accessRoles;
  //   for (var k = 0; k < roles.length; k++) {
  //     if (roles[k].page_id == page) {
  //       haveRole = true;
  //       break;
  //     }
  //   }
  //   if (haveRole == false) {
  //     next({ path: path, query: query });
  //     return;
  //   }
  // }

  next();
});

i18n.locale = store.state.layout.language;
// i18n.locale = "zh";

export const app = new Vue({
  router,
  store,
  i18n,
  mounted() {
    // console.log("ready");
  },
  render: h => h(App)
}).$mount("#app");
